<template>
  <core-modal-marketing
    :tag="marketing.tag"
    :tag-icon="marketing.icon"
    :subtitle="marketing.subtitle"
    :header-icon="marketing.icon"
  >

    <template #title>
      <template v-if="currentUser.isMember">Keep Preserving What Matters Most</template>
      <template v-else>Your Memories Protected FOREVER<sub class="reg-mark">®</sub></template>
    </template>

    <div class="text-center">
      <storage-product-selection :upsell-tracking="upsellTracking" />

      <core-upsell-features class="mt-8 text-left" :items="STORAGE_FEATURES" />

      <p class="mt-8">
        <u-link
          :to="EXTERNAL_URLS.storage"
          external
          class="text-sm text-gray-500 underline"
        >
          Learn More about FOREVER Storage
        </u-link>
      </p>
    </div>
  </core-modal-marketing>
</template>

<script setup>
  defineProps({
    upsellTracking: Object
  });

  const currentUser = useSessionStore().currentUser;
  const marketing = computed(() =>
    currentUser.isMember ? STORAGE_UPSELL_MEMBER_MARKETING : STORAGE_UPSELL_MARKETING
  );

  const STORAGE_FEATURES = [
    {
      title: 'Protect What Matters Most',
      description: 'Make room for every memory still to come.',
      icon: 'i-ri-heart-fill'
    },
    {
      title: 'Own Your Storage. Don’t Rent It.',
      description: 'Flexible payment options. Permanent ownership.',
      icon: 'i-ri-sparkling-fill'
    },
    {
      title: 'Built for Long-Term Preservation',
      description: 'Safeguarded for your lifetime plus 100 years.',
      icon: 'i-ri-shield-check-fill'
    }
  ];
</script>
